import React, { useState, useEffect, useRef, useCallback } from 'react';
import Popup from 'devextreme-react/popup';
import Button from 'devextreme-react/button';
import FileUploader from 'devextreme-react/file-uploader';
import notify from 'devextreme/ui/notify';
import styles from './UploadPopup.module.css'
import TextArea from 'devextreme-react/text-area';
import LoadIndicator from "devextreme-react/load-indicator";
import MessagePopup from '../messagePopup/MessagePopup';
import ChatWindow from '../chatWindow/chatWindow';
const { REACT_APP_SERVER_URL } = process.env;

const UploadPopup = (props) => {
  const [comment, setComment] = useState('');
  const [popupWidth, setPopupWidth] = useState('60%');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [popUpDisablingFlag, setPopUpDisablingFlag] = useState(false);
  const [isLoadIndicatorVisible, setIsLoadIndicatorVisible] = useState(false);
  const [isShowingFileList, setIsShowingFileList] = useState(true);
  const [isMessagePopupVisible, setMessagePopupVisibility] = useState(false);
  const [popupMessageContent, setPopupMessageContent] = useState('');
  const [commentsFromServer, setCommentsFromServer] = useState([]);


  const popup = useRef(null);
  const clear = useCallback(() => {
    // `current.instance` points to the UI component instance 
    popup.current.instance.clear();
  }, []);


  useEffect(() => {
    fetchSubCommentsFromServer();
    const handleResize = () => {
      const screenwidth = window.innerWidth;
      if (screenwidth < 768) {
        setPopupWidth('60%');
      } else {
        setPopupWidth('400px');
      }
    };



    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  const fetchSubCommentsFromServer = async () => {

    if (props.task_id) {
      fetch(`${REACT_APP_SERVER_URL}signatures?i=${props.task_id}&a=cu&s=c`, {
        method: "GET",
        credentials: "include",
      })
        .then((response) => response.json())
        .then((response) => {
          setCommentsFromServer(response.comments);
        });
    }
  };




  const uploadCommentsAndFiles = async () => {
    try {
      const formData = new FormData();

      // Add the comment and file to the formData
      if (comment !== "")
        formData.append("comment", comment);
      if (uploadedFiles.length > 0) {
        Array.from(uploadedFiles).forEach((file, index) => {
          formData.append(`Files[${index}]`, file);
        });
      }
      if (!uploadedFiles.length > 0 && comment == "") {
        resetPopup();
        notify("לא נתקבלו תגובה או קובץ", 'error', 3000);
        return ("no comments or files to upload");
      }
      notify('מעבד תגובה', 'info', 3000);
      resetPopup();

      const requestURL = `${REACT_APP_SERVER_URL}CommentOnSubtasks?task_id=${props.task_id}&function=comment_on_subtask`;

      await fetch(requestURL, {
        method: "POST",
        credentials: "include",
        body: formData, // Send formData as the request body
        // Headers are not manually set for multipart/form-data; the browser will set it
      })
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            props.refreshData();
            setPopupMessageContent(`תגובתך למשימה- ${props.taskName} -נשלחה בהצלחה`)
            setMessagePopupVisibility(true);


          } else {
            setPopupMessageContent(`תקלה בשליחת התגובה למשימה ${props.taskName}: ${response}`);
            setMessagePopupVisibility(true);
          }

          return response;
        })
        .catch((error) => {
          setPopupMessageContent(`תקלה בשליחת התגובה למשימה ${props.taskName}: ${error.message}`);
          setMessagePopupVisibility(true);
        });
    }
    catch (error) {
      setPopupMessageContent(`תקלה בשליחת התגובה למשימה ${props.taskName}: ${error.message}`);
      setMessagePopupVisibility(true);

    }
  }

  const handleFilesUploaded = (e) => {
    setUploadedFiles(prevFiles => [...prevFiles, ...Array.from(e.value)]);

  };

  const resetPopup = () => {
    setComment('');
    setUploadedFiles([]);
    setIsLoadIndicatorVisible(false)
    props.setUploadPopupVisibility(false);
    setPopUpDisablingFlag(false);
    setIsShowingFileList(false);
    setCommentsFromServer([]);

  };


  return (
    <div>
      <Popup
        titleRender={() => <div className={styles.uploadPopupTitle}>שלח תגובה או העלה קובץ</div>}
        visible={props.isUploadPopupVisible}
        onHiding={() => {
          resetPopup();
        }}
        onShowing={ () =>{ fetchSubCommentsFromServer();}}

        ref={popup}
        dragEnabled={true}
        closeOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        height="auto"
        width={popupWidth}
      >
        <div className={styles.popupContainer}>
        <div className={styles.uploadPopupContent}>
        <div className={styles.dxFieldValue}>
        <Button icon='pulldown' onClick={() => fetchSubCommentsFromServer()} />
        </div>
          <ChatWindow
           comments={commentsFromServer} 
           minHeight={40}
          />
          <div className={styles.dxField}>
            <div className={styles.dxFieldLabel}>תגובה:</div>
            <div className={styles.dxFieldValue}>
              <TextArea
                value={comment}
                showClearButton={true}
                onValueChanged={(e) => setComment(e.value)}
                stylingMode="outlined"
                autoResizeEnabled={true}
                minHeight={20}
                maxHeight={200}
                width="100%"
                className={styles.textArea}
              />

              <FileUploader
                id="popupFileUploader"
                disabled={popUpDisablingFlag}
                multiple={true}
                selectButtonText="בחר קבצים להעלאה"
                accept=".doc, .docx, .txt, .pdf, .jpeg, .jpg, .png, .gif"
                uploadMode="useForm"
                onValueChanged={(e) => {
                  handleFilesUploaded(e);
                  setIsShowingFileList(true);
                }}
                allowCanceling={true}
                showFileList={isShowingFileList}
                icon="upload"
              >
                <i className="fas fa-upload"></i>
              </FileUploader>
              <Button
                disabled={popUpDisablingFlag}
                width="100%"
                text="שלח"
                type="success"
                onClick={() => { setPopUpDisablingFlag(true); setIsLoadIndicatorVisible(true); uploadCommentsAndFiles(); }}
                icon="comment"
              />
            </div>
          </div>
          </div>

        </div>

      </Popup>
      <MessagePopup
        isMessagePopupVisible={isMessagePopupVisible}
        setMessagePopupVisibility={setMessagePopupVisibility}
        popupMessageContent={popupMessageContent}
        type={"error"}
      />
    </div>

  );

};

export default UploadPopup;
